import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './about-graph.scss';

export class AboutGraph extends PureComponent {
  render() {
    const { title, image } = this.props.graph;

    return (
      <div className="about-graph">
        <h4 dangerouslySetInnerHTML={{ __html: title }}/>
        <img src={image} alt={title} />
      </div>
    );
  }
}

AboutGraph.propTypes = {
  graph: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.string
  })
};

export default AboutGraph;



// WEBPACK FOOTER //
// ./src/components/About/AboutGraph.js